export default __webpack_public_path__ + "static/media/addDocument.bd7ac120.svg";